import {
  testDetailConstants,
  downloadTestFileConstants,
} from "../_redux-constants";
import { testDetailService } from "../../_services";

function getTestDetail(testId) {
  function testDetailLoad() {
    return { type: testDetailConstants.TEST_DETAIL_LOADING };
  }
  function testDetailSuccess(data) {
    return { type: testDetailConstants.TEST_DETAIL_SUCCESS, data };
  }
  function testDetailFailuer(error) {
    return { type: testDetailConstants.TEST_DETAIL_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(testDetailLoad());
    testDetailService.getTestDetails(testId).then(
      (data) => {
        dispatch(testDetailSuccess(data));
      },
      (error) => {
        dispatch(testDetailFailuer(error?.toString()));
      }
    );
  };
}

function downloadTestFile(queryParams) {
  function downloadTestFileLoad() {
    return { type: downloadTestFileConstants.DWNLD_TEST_FILE_LOADING };
  }
  function downloadTestFileSuccess(data) {
    return {
      type: downloadTestFileConstants.DWNLD_TEST_FILE_SUCCESS,
      data,
    };
  }
  function downloadTestFileFailure(error) {
    return {
      type: downloadTestFileConstants.DWNLD_TEST_FILE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(downloadTestFileLoad());
    return testDetailService.downloadTestFile(queryParams).then(
      (data) => {
        dispatch(downloadTestFileSuccess(data));
      },
      (error) => {
        dispatch(downloadTestFileFailure(error?.toString()));
      }
    );
  };
}

export const testDetailActions = {
  getTestDetail,
  downloadTestFile,
};
